export default class SiteHeader {
  constructor(el) {
    this.el = el;
    // this.init();
    // this.initEvents();
    this.account = document.querySelector(".account");
    this.Util = {
      append: function (markup, el) {
        if (typeof el == "string") {
          var els = document.querySelectorAll(el);
          for (var i = 0; i < els.length; i++) {
            els[i].insertAdjacentHTML("afterbegin", markup);
          }
        } else {
          el.insertAdjacentHTML("afterbegin", markup);
        }
      },

      simpleClone: function (obj) {
        return JSON.parse(JSON.stringify(obj));
      },

      hasClass: function (cl, el) {
        return el.className.split(" ").indexOf(cl.replace(".", "")) > -1;
      },

      addClass: function (cl, el) {
        if (el.className.trim() == "" || el.className.indexOf(cl) == -1) {
          el.className += " " + cl;
        }
      },

      removeClass: function (cl, el) {
        if (el.className.trim() != "" && el.className.indexOf(cl) > -1) {
          el.className = el.className.replace(new RegExp("\\s?" + cl), "");
        }
      },

      next: function (el, cl) {
        if (cl) {
          cl = cl.replace(".", "");
          return !el.nextElementSibling ||
            this.hasClass(cl, el.nextElementSibling)
            ? el.nextElementSibling
            : this.next(el.nextElementSibling, cl);
        } else {
          return el.nextElementSibling;
        }
      },

      prev: function (el, cl) {
        if (cl) {
          cl = cl.replace(".", "");
          return !el.previousElementSibling ||
            this.hasClass(cl, el.previousElementSibling)
            ? el.previousElementSibling
            : this.prev(el.previousElementSibling, cl);
        } else {
          return el.previousElementSibling;
        }
      },

      closest: function (cl, el) {
        cl = cl.replace(".", "");

        while (el.parentNode) {
          el = el.parentNode;

          if (this.hasClass(cl, el)) {
            return el;
            break;
          }
        }

        return false;
      },

      delegate: function (
        eventString,
        parentSelector,
        delegateSelector,
        callback
      ) {
        var els = document.querySelectorAll(parentSelector);
        var dS = delegateSelector.replace(/^(?:\.|#)/, "");

        function binding(ev) {
          if (ev.target) {
            if (ev.target.className.split(" ").indexOf(dS) > -1) callback(ev);
          }
        }

        // prevent the events from being bound multiple times
        this.delegated = this.delegated || {};
        // if the binding already exists, remove it, so it won't double up, but will
        // also allow for any new elements to be bound.
        var bindingKey = (
          eventString +
          parentSelector +
          delegateSelector
        ).replace(/\s/g, "");

        if (this.delegated[bindingKey]) {
          var old = this.delegated[bindingKey];

          for (var i = 0; i < old.els.length; i++) {
            els[i].removeEventListener(eventString, old.binding, true);
          }
        }

        this.delegated[bindingKey] = {
          els: els,
          binding: binding,
        };

        for (var i = 0; i < els.length; i++) {
          els[i]?.addEventListener(eventString, binding, true);
        }
      },
    };

    /**
     * A map of all the keyboard keys handled by this Class.
     * @type {Object}
     */
    this.keyMap = {
      TAB: 9,
      ENTER: 13,
      ESC: 27,
      SPACE: 32,
      LEFT: 37,
      UP: 38,
      RIGHT: 39,
      DOWN: 40,
    };
    /**
     * A map of selectors used to reference DOM nodes.
     * @type {Object}
     */
    this.selectors = {
      NAV_CONTAINER: ".js-navContainer",
      ROOT_ITEM: ".js-rootItem",
      ROOT_LIST_ITEM: ".js-rootListItem",
      NAV_LIST: ".js-navList",
      LIST_ITEM: ".js-listItem",
      NAV_ITEM: ".js-navItem",
      COLUMN_ITEM: ".js-columnItem",
      NAV_ITEM_WITH_SUB_NAV: ".js-navItemWithSubNav",
      SUB_NAV_COLUMNS: ".js-subNavColumns",
      SUB_NAV_COLUMN_SEPARATOR: ".js-subNavColumnSeparator",
      SUB_NAV_TOGGLE_BTN: ".js-subNavToggleBtn",
      ARIA_NOT_HIDDEN: '[aria-hidden="false"]',
    };
    /**
     * A map of CSS classes used to modifiy the state of a DOM node.
     * @type {Object}
     */
    this.cssModifiers = {
      IS_VISIBLE: "is--visible",
      IS_ROOT_NAV: "is--root-nav",
      IS_CLOSED: "is--closed",
      IS_OPEN: "is--open",
      HAS_OPEN_SUB: "has--open-sub",
    };
    /**
     * A map of Event types handled by this Class.
     * @type {Object}
     */
    this.events = {
      CLICK: "click",
      MOUSE_OVER: "mouseover",
      KEY_UP: "keyup",
      KEY_DOWN: "keydown",
    };
    /**
     * A map of ARIA attributes handled by this Class.
     * @type {Object}
     */
    this.ariaAttributes = {
      HIDDEN: "aria-hidden",
      LABEL: "aria-label",
    };
    /**
     * Whether or not the user is interacting with the nav via the keyboard.
     * @type {Boolean}
     */
    this.triggeredByKeyboard = false;
    /**
     * Will be executed when a user clicks on a nav link.
     * @type {Object}
     */
    this.onLinkClick = this.handleNavLinkClicks || undefined;
    /**
     * Will be executed when a user clicks on a nav button.
     * @type {Object}
     */
    this.onBtnClick = this.handleNavLinkClicks || undefined;
    /**
     * A map of the types of navs this Class supports.
     * @type {Object}
     */
    this.navTypes = {
      ACCORDIAN: "accordian",
      COLUMN: "column",
      DROP_DOWN: "dropDown",
    };
    /**
     * The type of nav that will be set up.
     * @type {String}
     */
    this.navType = "column" || this.navTypes.DROP_DOWN;
    /**
     * A unique identifier used for event delegation and styling.
     * @type {String|null}
     */
    this.navClass = "is-for--column-nav" || null;
    this.addListeners();
  }
  /**
   * Show the dropdown from the account
   * @param {Event} ev - Click event.
   *
   */
  showDropdownTop(ev) {
    ev.preventDefault();
    ev.target.parentNode
      .querySelector(".c-nav-top--dropdown")
      .classList.toggle("active");
  }
  // init();
  // initEvents();

  /**
   * Checks if the element belongs to a root item, so it knows whether or not to close a sub nav or keep iterating over nav elements.
   *
   * @param {HTMLElement} subNav - The sub nav that the current element the user selected belongs to.
   * @param {HTMLElement} el - The element the user is on.
   */
  rootItemCheck(subNav, el) {
    return this.navType == this.navTypes.COLUMN
      ? !!subNav.parentNode.parentNode.querySelector(
          this.selectors.ROOT_ITEM
        ) && !this.Util.hasClass(this.selectors.ROOT_ITEM, el)
      : !!subNav.parentNode.querySelector(this.selectors.ROOT_ITEM) &&
          !this.Util.hasClass(this.selectors.ROOT_ITEM, el);
  }

  /**
   * Selects the next item in nav. If there isn't one it'll bounce back to the first item in the list. If it's at the end
   * of a sub nav that belongs to a root item, it'll close the nav and refocus the root item.
   *
   * @param {HTMLElement} el - The element the user is on.
   * @param {Boolean} [openSub] - Whether or not to open a sub nav.
   * @param {Number} [direction] - The keyboard key code of the direction the user chose.
   */
  selectNextNavItem(el, openSub, direction) {
    var menu = this.Util.closest(this.selectors.NAV_LIST, el);
    var hasRootParent = this.rootItemCheck(menu, el);
    var closeSub = false;
    var nextEl = this.Util.next(el.parentNode);

    if (!nextEl) {
      nextEl = menu.children[0];
      if (hasRootParent || this.navType == this.navTypes.ACCORDIAN)
        closeSub = true;
    }

    if (
      !openSub &&
      this.Util.hasClass(this.selectors.COLUMN_ITEM, el) &&
      direction
    ) {
      var nextMenu = this.Util.next(menu, this.selectors.NAV_LIST);

      if (nextMenu) {
        menu = nextMenu;
        this.columnIndex++;
      } else {
        menu = menu.parentNode.children[0];
        this.columnIndex = 0;
      }

      // select the next horizontal item, or the last item in the next menu.
      var nextHorizontalEl = menu.children[this.itemIndex];
      if (nextHorizontalEl) {
        nextEl = nextHorizontalEl;
      } else {
        this.itemIndex = menu.children.length - 1;
        nextEl = menu.children[this.itemIndex];
      }

      closeSub = false;
    } else if (!openSub && direction) {
      this.columnIndex = 0;
    }

    if (
      this.navType == this.navTypes.COLUMN &&
      !openSub &&
      !direction &&
      !closeSub
    ) {
      this.itemIndex++;
    }

    if (openSub) {
      if (this.navType == this.navTypes.COLUMN) {
        this.itemIndex = 0;

        // unhide all columns
        var columns = this.Util.next(el).querySelectorAll(
          this.selectors.NAV_LIST
        );

        for (var i = 0; i < columns.length; i++) {
          columns[i].setAttribute(this.ariaAttributes.HIDDEN, false);
        }

        this.Util.addClass(this.cssModifiers.IS_VISIBLE, this.Util.next(el));
        if (!this.columnIndex) this.columnIndex = 0;
        nextEl = columns[this.columnIndex];
      } else {
        nextEl = el.parentNode.querySelector(this.selectors.NAV_LIST);
        nextEl.setAttribute(this.ariaAttributes.HIDDEN, false);
      }

      if (this.triggeredByKeyboard)
        this.Util.addClass(this.cssModifiers.HAS_OPEN_SUB, el.parentNode);
    } else if (closeSub) {
      if (this.navType == this.navTypes.COLUMN) {
        // hide all columns
        var columns = menu.parentNode.querySelectorAll(this.selectors.NAV_LIST);

        for (var i = 0; i < columns.length; i++) {
          columns[i].setAttribute(this.ariaAttributes.HIDDEN, true);
        }

        this.Util.removeClass(this.cssModifiers.IS_VISIBLE, menu.parentNode);
        nextEl = menu.parentNode.parentNode;
      } else if (!this.Util.hasClass(this.cssModifiers.IS_ROOT_NAV, menu)) {
        nextEl = menu.parentNode;
        menu.setAttribute(this.ariaAttributes.HIDDEN, true);

        if (this.navType == this.navTypes.ACCORDIAN) {
          this.closeAccordianSubNav(
            nextEl.querySelector(this.selectors.SUB_NAV_TOGGLE_BTN),
            menu
          );
        }
      }

      if (this.triggeredByKeyboard)
        this.Util.removeClass(this.cssModifiers.HAS_OPEN_SUB, nextEl);
    }
    if (nextEl.querySelector(this.selectors.NAV_ITEM) != null) {
      nextEl.querySelector(this.selectors.NAV_ITEM).focus();
    } else {
      nextEl = menu.children[1];
      nextEl.querySelector(this.selectors.NAV_ITEM).focus();
    }
  }

  /**
   * Selects the previous item in nav. If there isn't one it'll bounce to the last item in the list. If it's at the start
   * of a sub nav that belongs to a root item, it'll close the nav and refocus the root item.
   *
   * @param {HTMLElement} el - The element the user is on.
   * @param {Boolean} [closeSub] - Whether or not to close a sub nav.
   * @param {Number} [direction] - The keyboard key code of the direction the user chose.
   */
  selectPreviousNavItem(el, closeSub, direction) {
    var menu = this.Util.closest(this.selectors.NAV_LIST, el);
    var hasRootParent = this.rootItemCheck(menu, el);
    var prevEl = this.Util.prev(el.parentNode);

    if (!prevEl) {
      prevEl = menu.children[menu.children.length - 1];
      if (
        (hasRootParent && closeSub == undefined) ||
        this.navType == this.navTypes.ACCORDIAN
      )
        closeSub = true;
    }

    if (
      !closeSub &&
      this.Util.hasClass(this.selectors.COLUMN_ITEM, el) &&
      direction
    ) {
      var prevMenu = this.Util.prev(menu, this.selectors.NAV_LIST);

      if (prevMenu) {
        menu = prevMenu;
        this.columnIndex--;
      } else {
        this.columnIndex = menu.parentNode.children.length - 1;
        menu = menu.parentNode.children[this.columnIndex];
      }

      // select the previous horizontal item, or the last item in the previous menu.
      var prevHorizontalEl = menu.children[this.itemIndex];
      if (prevHorizontalEl) {
        prevEl = prevHorizontalEl;
      } else {
        this.itemIndex = menu.children.length - 1;
        prevEl = menu.children[this.itemIndex];
      }

      closeSub = false;
    } else if (!closeSub && direction) {
      this.columnIndex = 0;
    }

    if (this.navType == this.navTypes.COLUMN && !direction && !closeSub) {
      this.itemIndex--;
    }

    if (closeSub) {
      if (this.navType == this.navTypes.COLUMN) {
        // hide all columns
        var columns = menu.parentNode.querySelectorAll(this.selectors.NAV_LIST);

        for (var i = 0; i < columns.length; i++) {
          columns[i].setAttribute(this.ariaAttributes.HIDDEN, true);
        }

        this.Util.removeClass(this.cssModifiers.IS_VISIBLE, menu.parentNode);
        prevEl = menu.parentNode.parentNode;
      } else if (!this.Util.hasClass(this.cssModifiers.IS_ROOT_NAV, menu)) {
        prevEl = menu.parentNode;
        menu.setAttribute(this.ariaAttributes.HIDDEN, true);

        if (this.navType == this.navTypes.ACCORDIAN) {
          this.closeAccordianSubNav(
            prevEl.querySelector(this.selectors.SUB_NAV_TOGGLE_BTN),
            menu
          );
        }
      }

      if (this.triggeredByKeyboard)
        this.Util.removeClass(this.cssModifiers.HAS_OPEN_SUB, prevEl);
    }
    const prev = prevEl.querySelector(this.selectors.NAV_ITEM);
    if (prev != null) {
      prevEl.querySelector(this.selectors.NAV_ITEM).focus();
    } else {
      prevEl = menu.children[1];
      prevEl.querySelector(this.selectors.NAV_ITEM).focus();
    }
  }

  /**
   * Remove any visual indicators used to display an open sub nav.
   *
   * @param {HTMLElement} parentEl - All child elements with CSS class will be reset.
   */
  removeOpenSubState(parentEl) {
    var elsWithClass = parentEl.querySelectorAll(
      "." + this.cssModifiers.HAS_OPEN_SUB
    );

    // remove any visual indicators used to display an open sub nav
    for (var i = 0; i < elsWithClass.length; i++) {
      this.Util.removeClass(this.cssModifiers.HAS_OPEN_SUB, elsWithClass[i]);
    }
  }

  /**
   * Closes all open sub navs and will return focus to the root item.
   *
   * @param {Event} ev - Normally a keyboard event with ESC or TAB. Could also be triggered if the user starts
   * using a mouse (mouseover) after they've been using the keyboard.
   */
  closeOpenNavs(ev) {
    var cont = ev.currentTarget;
    var item = ev.target;
    var isEscape = ev.keyCode == this.keyMap.ESC;
    var isTab = ev.keyCode == this.keyMap.TAB;

    if (this.triggeredByKeyboard) {
      // only close the sub navs if you're at the top/bottom of the nav list on TAB
      if (isTab) {
        if (ev.shiftKey && this.Util.prev(item.parentNode)) return;
        if (!ev.shiftKey && this.Util.next(item.parentNode)) return;
      }

      var visibleNavs = cont.querySelectorAll(this.selectors.ARIA_NOT_HIDDEN);

      if (visibleNavs.length > 1) {
        this.removeOpenSubState(cont);

        // closes all sub navs, resets ARIA attributes, and selects the root item
        for (var i = 0; i < visibleNavs.length; i++) {
          var nav = visibleNavs[i];

          if (this.Util.hasClass(this.cssModifiers.IS_ROOT_NAV, nav)) {
            // root item should regain focus on escape
            if (isEscape || isTab) {
              this.Util.closest(this.selectors.ROOT_LIST_ITEM, item)
                .querySelector(this.selectors.ROOT_ITEM)
                .focus();

              // without this, SHIFT+TAB will select the previous item after we've selected the root item
              ev.preventDefault();
            }
            // blur any root items that had focus so they don't stay highlighted on hover
            else {
              document.activeElement.blur();
            }
          }
          // close open sub menus
          else {
            nav.setAttribute(this.ariaAttributes.HIDDEN, true);

            if (this.navType == this.navTypes.ACCORDIAN) {
              this.closeAccordianSubNav(
                nav.parentNode.querySelector(this.selectors.SUB_NAV_TOGGLE_BTN),
                nav
              );
            }
          }
        }

        if (this.navType == this.navTypes.COLUMN && visibleNavs.length) {
          // node zero will always be the root node
          this.Util.removeClass(
            this.cssModifiers.IS_VISIBLE,
            visibleNavs[1].parentNode
          );
          this.columnIndex = 0;
        }
      }

      this.triggeredByKeyboard = false;
    }
  }

  /**
   * User has clicked a nav link. A link with a target keeps the browser's
   * default behaviour, so it opens in the window the editor chose.
   *
   * @param {Event} ev - Click event.
   */
  handleLinkClick(ev) {
    if (ev.target.getAttribute("target")) return;

    ev.preventDefault();
    window.location = ev.target.getAttribute("href");
  }

  /**
   * User has clicked a nav button.
   *
   * @param {Event} ev - Click event.
   */
  handleBtnClick(ev) {
    ev.preventDefault();

    if (this.onBtnClick) {
      this.onBtnClick(ev);
    }
  }

  /**
   * Handles navigation via keyboard events.
   *
   * @param {Event} ev - Keyboard events.
   */
  handleKeyUp(ev) {
    var el = ev.target;

    this.triggeredByKeyboard = true;

    switch (ev.keyCode) {
      case this.keyMap.LEFT:
        // Only allow accordian menus to move up and down
        if (this.navType != this.navTypes.ACCORDIAN) {
          // root els go left to right
          if (
            this.Util.hasClass(this.selectors.ROOT_ITEM, el) ||
            this.Util.hasClass(this.selectors.COLUMN_ITEM, el)
          ) {
            this.selectPreviousNavItem(el, false, this.keyMap.LEFT);
          }
          // close the current menu
          else {
            this.selectPreviousNavItem(el, true);
          }
        }
        break;

      case this.keyMap.UP:
        this.selectPreviousNavItem(el);
        break;

      case this.keyMap.RIGHT:
        // Only allow accordian menus to move up and down
        if (this.navType != this.navTypes.ACCORDIAN) {
          // root els & columns go left to right
          if (
            this.Util.hasClass(this.selectors.ROOT_ITEM, el) ||
            this.Util.hasClass(this.selectors.COLUMN_ITEM, el)
          ) {
            this.selectNextNavItem(el, false, this.keyMap.RIGHT);
          }
          // sub items will open the next menu
          else if (
            this.Util.hasClass(this.selectors.NAV_ITEM_WITH_SUB_NAV, el)
          ) {
            this.selectNextNavItem(el, true);
          }
        }
        break;

      case this.keyMap.DOWN:
        if (
          this.Util.hasClass(this.selectors.ROOT_ITEM, el) &&
          this.Util.hasClass(this.selectors.NAV_ITEM_WITH_SUB_NAV, el) &&
          this.navType != this.navTypes.ACCORDIAN
        ) {
          this.selectNextNavItem(el, true);
        } else {
          this.selectNextNavItem(el);
        }
        break;

      case this.keyMap.SPACE:
        if (this.Util.hasClass(this.selectors.NAV_ITEM_WITH_SUB_NAV, el)) {
          if (this.navType == this.navTypes.ACCORDIAN) {
            this.handleMenuToggle(ev);
          } else {
            this.selectNextNavItem(el, true);
          }
        }
        break;

      case this.keyMap.ESC:
        this.closeOpenNavs(ev);
        break;
    }
  }

  /**
   * Handles navigation via keyboard events. Some keys need to be captured on down otherwise we can't intercept them.
   *
   * @param {Event} ev - Keyboard events.
   */
  handleKeyDown(ev) {
    var dontScrollThese = [
      this.keyMap.UP,
      this.keyMap.DOWN,
      this.keyMap.LEFT,
      this.keyMap.RIGHT,
      this.keyMap.SPACE,
    ].join("|");

    if (new RegExp(dontScrollThese).test(ev.keyCode)) {
      ev.preventDefault();
    }

    switch (ev.keyCode) {
      case this.keyMap.TAB:
        this.closeOpenNavs(ev);
        break;
    }
  }

  /**
   * Handles all clicks within a nav and forwards them on to their proper functionality.
   *
   * @param {Event} ev - Click event.
   */
  handleClick(ev) {
    var el = ev.target;

    if (el.getAttribute("href")) this.handleLinkClick(ev);
    else if (this.Util.hasClass(this.selectors.SUB_NAV_TOGGLE_BTN, el))
      this.handleMenuToggle(ev);
    else this.handleBtnClick(ev);
  }

  /**
   * Adds all event bindings for the nav.
   */
  addListeners() {
    var contSelector = this.selectors.NAV_CONTAINER;
    if (this.navClass) contSelector += "." + this.navClass;

    this.Util.delegate(
      this.events.MOUSE_OVER,
      contSelector,
      this.selectors.NAV_ITEM,
      this.closeOpenNavs.bind(this)
    );
    this.Util.delegate(
      this.events.KEY_DOWN,
      contSelector,
      this.selectors.NAV_ITEM,
      this.handleKeyDown.bind(this)
    );
    this.Util.delegate(
      this.events.KEY_UP,
      contSelector,
      this.selectors.NAV_ITEM,
      this.handleKeyUp.bind(this)
    );
    this.Util.delegate(
      this.events.CLICK,
      contSelector,
      this.selectors.NAV_ITEM,
      this.handleClick.bind(this)
    );
    this.Util.delegate(
      this.events.CLICK,
      contSelector,
      this.selectors.SUB_NAV_TOGGLE_BTN,
      this.handleClick.bind(this)
    );

    this.Util.delegate(
      this.events.CLICK,
      ".account",
      "c-link--dropdown",
      this.showDropdownTop.bind(this)
    );
    this.Util.delegate(
      this.events.CLICK,
      ".c-header__current-centra",
      "c-link--dropdown",
      this.showDropdownTop.bind(this)
    );
    this.Util.delegate(
      this.events.CLICK,
      ".c-header__current-language",
      "c-link--dropdown",
      this.showDropdownTop.bind(this)
    );
    
    document.querySelector(".column-nav .account .c-link--dropdown .my-sv-title")?.addEventListener("click", function(evt){
      evt.preventDefault();
      document.querySelector(".column-nav .account .c-link--dropdown")?.click();
    }, false);
    document.querySelector(".c-site-header-mobile .account .c-link--dropdown .my-sv-title")?.addEventListener("click", function(evt){
      evt.preventDefault();
      document.querySelector(".c-site-header-mobile .account .c-link--dropdown").click();
    }, false);
    document.querySelector(".column-nav .account .c-link--dropdown img")?.addEventListener("click", function(evt){
      evt.preventDefault();
      document.querySelector(".column-nav .account .c-link--dropdown").click();
    }, false);
    document.querySelector(".c-site-header-mobile .account .c-link--dropdown img")?.addEventListener("click", function(evt){
      evt.preventDefault();
      document.querySelector(".c-site-header-mobile .account .c-link--dropdown").click();
    }, false);
  }

  handleNavLinkClicks(ev) {
    var el = document.querySelector(".js-clickOutput");
    console.log(ev);

    //el.innerHTML = "";
    // this.Util.append(
    //   "Route page to: <u>" + ev.target.getAttribute("href") + "</u>",
    //   el
    // );
  }
}
